const AgeBanner = () => {
    return (
        <div className="age-banner">
            <span className="age-badge">18+</span>
            <span>This website is intended for <strong>adults only</strong>. By continuing, you confirm you are 18 years or
                older.</span>
        </div>
    )
}

export default AgeBanner